// @flow
import styled from 'styled-components';
import {
  background,
  border,
  color,
  compose,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  system,
  typography,
} from 'styled-system';

const cursorStyleFn = system({
  cursor: true,
});

const styleProps = compose(
  background,
  border,
  color,
  cursorStyleFn,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  typography
)

export const Input = styled.input`
  ${styleProps}
`;
